import React from 'react';
import {
  Box,
  Select,
  Text,
  VStack,
  HStack,
  Badge,
  Spinner
} from '@chakra-ui/react';

interface TagSelectorProps {
  tags: string[];
  selectedTag: string | null;
  onTagChange: (tag: string | null) => void;
  loading: boolean;
}

const TagSelector: React.FC<TagSelectorProps> = ({
  tags,
  selectedTag,
  onTagChange,
  loading
}) => {
  const handleTagChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    onTagChange(value === '' ? null : value);
  };

  return (
    <Box
      bg="white"
      p={4}
      borderRadius="lg"
      boxShadow="sm"
      border="1px"
      borderColor="gray.200"
    >
      <VStack spacing={3} align="stretch">
        <HStack justify="space-between" align="center">
          <Text fontSize="lg" fontWeight="medium" color="gray.700">
            Filter by Tag
          </Text>
          {loading && <Spinner size="sm" color="blue.500" />}
        </HStack>
        
        <Select
          value={selectedTag || ''}
          onChange={handleTagChange}
          placeholder="Select a tag to filter strategies"
          size="md"
          bg="white"
          borderColor="gray.300"
          _hover={{ borderColor: 'blue.400' }}
          _focus={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px var(--chakra-colors-blue-500)' }}
        >
          <option value="">All Strategies</option>
          {tags.map((tag) => (
            <option key={tag} value={tag}>
              {tag}
            </option>
          ))}
        </Select>

        {selectedTag && (
          <HStack spacing={2}>
            <Text fontSize="sm" color="gray.600">
              Active filter:
            </Text>
            <Badge colorScheme="blue" variant="subtle" fontSize="sm">
              {selectedTag}
            </Badge>
          </HStack>
        )}

        <Text fontSize="xs" color="gray.500">
          {tags.length} tag{tags.length !== 1 ? 's' : ''} available
        </Text>
      </VStack>
    </Box>
  );
};

export default TagSelector;
